/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionSummary
 */
export interface PermissionSummary {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PermissionSummary
     */
    resourcePermissionCounts?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PermissionSummary
     */
    actionPermissionCounts?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof PermissionSummary
     */
    totalPermissions?: number;
}

/**
 * Check if a given object implements the PermissionSummary interface.
 */
export function instanceOfPermissionSummary(value: object): value is PermissionSummary {
    return true;
}

export function PermissionSummaryFromJSON(json: any): PermissionSummary {
    return PermissionSummaryFromJSONTyped(json, false);
}

export function PermissionSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'resourcePermissionCounts': json['resource_permission_counts'] == null ? undefined : json['resource_permission_counts'],
        'actionPermissionCounts': json['action_permission_counts'] == null ? undefined : json['action_permission_counts'],
        'totalPermissions': json['total_permissions'] == null ? undefined : json['total_permissions'],
    };
}

export function PermissionSummaryToJSON(json: any): PermissionSummary {
    return PermissionSummaryToJSONTyped(json, false);
}

export function PermissionSummaryToJSONTyped(value?: PermissionSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resource_permission_counts': value['resourcePermissionCounts'],
        'action_permission_counts': value['actionPermissionCounts'],
        'total_permissions': value['totalPermissions'],
    };
}

